export default "__VITE_ASSET__K4UY8y7A__"